'use strict';

angular.module('app.advertiserPreferredList', [])

.controller('advertiserPreferredListCtrl', ['$scope', '$rootScope', '$modal', '$http', '$state', '$location', function ($scope, $rootScope, $modal, $http, $state, $location) {
    
    $scope.currentUser = $rootScope.currentUser;
    $scope.showEdit = false;
    $scope.limitList = 10;
    $scope.showAll = false;

    if($scope.currentUser.accessibility.leftMenu.showCurrentlyManaging == false && $scope.currentUser.accessibility.leftMenu.showPreferred == true) {
        $scope.preferedBlogs = $scope.currentUser.company.preferedBlogs;
        $scope.showEdit = true;
    }

    $scope.$on('reload_advertiserPreferredList', function(event, args) {
        var url_getAllProject = $rootScope.apiUrl + 'common/getAllPreferedBlogByAdvertiserID/' + args.advertiserId;
        $http.get(url_getAllProject, {loader: false}).
            success(function (response) {
                $scope.preferedBlogs = response.data;
                $scope.showEdit = true;
                if($rootScope.sideMenuSelections.blog != null) {
                    setTimeout(function () {
                        $scope.markPreferred($rootScope.sideMenuSelections.blog);
                    }, 5)
                }
            }).error(function (response) {
                return false;
        });       
    });

    $scope.markPreferred = function(id){
        $(".kws ul li a").removeClass("active");
        $(".influencers ul li a").removeClass("active");
        $(".preferred ul li").removeClass('activePreferred');

        $('.main-sidebar .projects .nav-sidebar .project .kws li a').removeClass('active');
        $('.main-sidebar .projects .nav-sidebar .project').removeClass('active');
        $('.main-sidebar .projects .nav-sidebar .project').removeClass('not-selected');
        $('.main-sidebar .projects .nav-sidebar .project .kws').hide();

        $('.main-sidebar .influencerGroups .nav-sidebar .influencerGroup .influencers li a').removeClass('active');
        $('.main-sidebar .influencerGroups .nav-sidebar .influencerGroup').removeClass('active');
        $('.main-sidebar .influencerGroups .nav-sidebar .influencerGroup').removeClass('not-selected');
        $('.main-sidebar .influencerGroups .nav-sidebar .influencerGroup .influencers').hide();

        $('.main-sidebar .campaigns .nav-sidebar .campaign').removeClass('active');

        $(".preferred ul li#preferred_" + id).addClass('activePreferred');
    }

    $scope.selectPreferred = function(id){

        $scope.markPreferred(id);

        $rootScope.sideMenuSelections.project = null;
        $rootScope.sideMenuSelections.keyword = null;
        $rootScope.sideMenuSelections.blog = id;
        $rootScope.sideMenuSelections.channel = null;           
        $rootScope.sideMenuSelections.influencerGroup = null;

        $rootScope.saveParams = {
            project_id : 0,
            mention : 0,
            blog_id : id ? id : 0,
            channel: 0,
            influencerGroup: 0,
            _workaround_group_id: 0
        };

        $rootScope.$broadcast('updatePrintHeader', { printHeader : {
            type: "Influencer",
            name: $(".preferred ul li.activePreferred").text()
        }});

        $rootScope.$broadcast('refreshDashboard', {});
        $rootScope.$broadcast('changeDiscoverPreferred', {});

        if($state.current.name == "home.blogPostOverview" || $state.current.name == "home.instagramPostOverview" || $state.current.name == "home.youtubePostOverview") {
            $state.transitionTo("home.dashboard", null, {
                reload: false,
                inherit: false,
                notify: true
            });
        }

        if($state.current.name == "home.influencer" || $state.current.name == "home.detailInfluencerGroup" || $state.current.name == "home.influencerOverview" ) {
            $rootScope.previousPage = $location.absUrl();
            $state.transitionTo('home.influencerOverview', {influencer_id: id}, {
                reload: false,
                inherit: true,
                notify: true
            });
        }
    }

    $scope.preferred_toggleAll = function(e){
        $(e.target).text($scope.showAll ? 'Show All' : 'Hide');
        $scope.showAll = !$scope.showAll;
    }

    $scope.newPreferredModalHandler = function () {
        var modalInstance = $modal.open({
            scope: $scope,
            templateUrl: 'app/sideBarMenu/advertiserPreferredList/advertiserPerferredDetail/advertiserPerferredDetail.html?app_v=deployDate',
            controller: 'advertiserPerferredDetailCtrl'
        });

        $scope.modalInstance = modalInstance;
    }

 }])